import pricing from "./Pricing/Pricing";

const teamMemberMax = {
    team: pricing[2].team,
    business: pricing[3].team,
    enterprise: pricing[4].team
}

export default teamMemberMax